<template>
  <main-template>
    <template v-slot:main>

      <div class="page_top">
        <h1 class="title">
          <span>Расчеты</span>
        </h1>
      </div>



      <div class="page_content">
        <p class="empty">Здесь пока ничего нет</p>
      </div>


    </template>
  </main-template>
</template>

<script>
import MainTemplate from '@/components/MainTemplate.vue';






export default {
  name: 'CalculationsView',
  components: {
    MainTemplate,
  },
  data() {
    return{

    }
  },
  mounted() {

  },
  methods : {

  }
}
</script>

<style scoped>

p.empty {
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

/*MOBILE*/
@media (max-width: 1250px)
{

}
</style>



<style>



/*MOBILE*/
@media (max-width: 1250px)
{

}

</style>
